import { createReferenceAdapter } from '../../base';
import type { TranslationRefKey } from './translations.schema';

const references: TranslationRefKey[] = [
  'topics',
  'sms',
  'greetings',
  'disclaimerMessages',
  'behaviour',
];

export const translationReferencesAdapter = createReferenceAdapter(references);
